import { Card, CardContent, Grid, makeStyles } from "@material-ui/core";
import CardTitle from "@saleor/components/CardTitle";
import {
  DatePicker,
  TimePicker
} from "@saleor/components/DatePicker_TimePicker/DatePicker_TimePicker";
import {
  CouponCollectionErrorForm,
  CouponCollectionFormData
} from "@saleor/utils/validators/couponCollection";
import React, { ChangeEvent } from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  () => ({
    card: {
      width: "63%"
    },
    mainCard: {
      marginBottom: "20px"
    },
    rows: {
      display: "flex",
      flexDirection: "column",
      height: "204px",
      justifyContent: "space-around"
    },
    titleBar: {
      "& span": {
        flex: "none",
        fontWeight: "bolder",
        lineBreak: "anywhere",
        width: "-webkit-fill-available"
      }
    }
  }),
  { name: "CouponCollectionSchedule" }
);

interface CouponCollectionScheduleProps {
  disabled: boolean;
  data: CouponCollectionFormData;
  onChange: (event: ChangeEvent<any>) => void;
  localError?: CouponCollectionErrorForm;
}

export const CouponCollectionSchedule: React.FC<CouponCollectionScheduleProps> = props => {
  const { data, onChange, localError, disabled } = props;
  const classes = useStyles({});
  const intl = useIntl();

  return (
    <Card className={classes.mainCard}>
      <CardTitle
        className={classes.titleBar}
        title={intl.formatMessage({
          defaultMessage: "Coupon Collection Availability",
          description: "time coupon collection is active, header"
        })}
      />
      <CardContent className={classes.rows}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <DatePicker
              id="startDate"
              label="Start Date"
              value={data?.startDate}
              onChange={onChange}
              inputProps={{
                max: data?.endDate,
                min: new Date().toISOString().split("T")[0]
              }}
              disabled={disabled}
              localError={localError?.startDate}
            />
            <TimePicker
              id="startTime"
              label="Start Time"
              value={data?.startTime}
              onChange={onChange}
              disabled={disabled}
              localError={localError?.startTime}
            />
          </Grid>
          <Grid item xs={6}>
            <DatePicker
              id="endDate"
              label="End Date"
              value={data?.endDate}
              onChange={onChange}
              inputProps={{
                min: data?.startDate
              }}
              disabled={disabled}
              localError={localError?.endDate}
            />
            <TimePicker
              id="endTime"
              label="End Time"
              value={data?.endTime}
              onChange={onChange}
              disabled={disabled}
              localError={localError?.endTime}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CouponCollectionSchedule;
